/**
 * /cli/authorize（「この端末の Kumo CLI を許可」・pages/CliAuthorize.tsx）の英語の文言（2026-09-28 creator/connect）。en.ts が `...enCliAuth` で取り込む
 * （ja.cliAuth.ts が同じキーを全部持つことを型で強制）。
 * 決め事（指示書）: 「自分で connect / login を実行していなければ押さない」を目立たせる。端末の名前は CLI の申告（偽れる）と分かる書き方にする。
 * CLI のコマンドは {connect} / {login} で差し込む（cliCommand.ts の CLI = 改名に備える）。
 */
export const enCliAuth = {
  'cliAuth.title': 'Sign in on this computer?',
  'cliAuth.lead': 'You can then make and publish apps from this computer.',
  // 安全の 1 行・ログイン中（見える所 = 中の言葉を書かない・2026-10-03 console/plain-confirm）
  'cliAuth.safety': 'If you are not trying to sign in yourself, press Cancel.',
  // クラウドで動く CLI（2026-10-07 creator/remote-login）: 押した後ブラウザが 127.0.0.1 に移れないとき、アドレス欄の URL を貼ってもらう。押す前に見える所に 1 行
  'cliAuth.pasteHint': 'If your browser then says it cannot connect to 127.0.0.1, copy the whole address from the address bar and paste it where you ran the command (or into the chat with the AI that ran it).',
  'cliAuth.signedInAs': 'Signed in as {email}',
  'cliAuth.device': 'Computer (as the CLI named it)',
  'cliAuth.deviceUnknown': 'Not given',
  'cliAuth.time': 'Requested',
  'cliAuth.warning': 'Only press Allow if you ran {connect} or {login} yourself just now. If someone sent you this link, press Cancel.',
  'cliAuth.grants':
    'Allowing signs the CLI in as you (like this browser): it can create projects, deploy, and change settings. We email you when a CLI signs in; run logout in that CLI to sign it out.',
  'cliAuth.allow': 'Sign in',
  'cliAuth.cancel': 'Cancel',
  'cliAuth.unverifiedThen': 'After confirming your email, reload this page to sign in (or start again from your computer).',
  'cliAuth.unexpectedRedirect': 'Something unexpected came back, so nothing was sent. Start signing in again from your computer.',
  'cliAuth.allowedTitle': 'Signed in',
  'cliAuth.allowedBody': 'Go back to your computer screen. You can close this tab.',
  'cliAuth.cancelledTitle': 'Cancelled',
  'cliAuth.cancelledBody': 'You were not signed in. You can close this tab.',
  'cliAuth.invalidTitle': 'This link does not work',
  'cliAuth.invalidBody': 'It is incomplete or was changed. Run {login} or {connect} again in your terminal; it opens a new link.'
} as const;
